module.exports = __webpack_public_path__ + "assets/img/news (6).4d2a54ac.png";